<div class="d-flex justify-content-center align-items-center vh-100">
  @if (loading) {
    <div class="text-center">
      <div class="spinner-border text-primary mb-3" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="text-muted">Authenticating…</p>
    </div>
  }
  
</div>
